import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";
import Abutton from '../../library/ExtendedObjects/AButton.js';

export default class trayMini extends AContainer
{
    constructor(scene, parentCont, type)
    {
        //console.log("adding tray", type);
        super(scene);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type; 

        this.dots = [];
        this.cursorSizes = [[1, .75, .5, 1], [.9, .7, .5, .8]];
        this.adjX = 0;
        this.adjY = 0;

        this.createBaseTray();
        this.type === "color" ? this.createColorTray() : this.createSizeTray();
    }

    createBaseTray()
    {
        this.btns = [];

        this.tray = this.scene.add.container();
        this.pCont.pCont.addAt(this.tray, 0);

        this.trayBG = this.scene.addImage(0, 0, "Letters_Color_Tray", this.tray);

        this.cursor = this.scene.addImage(0, 0, "dotCursor", this.tray);
        this.cursor.setScale(0, 0);

        this.type === "color" ? this.tray.setPosition(95, 175) : this.tray.setPosition(95, 325);
    }

    createColorTray()
    {
        for(let i=0;i<13;i++){
            let color = this.scene.addButton(0, 0, "dot", null, ()=>{
                this.scene.playSound("select_color_pattern_face");

                color.tintColor = gameData.dotColors[i];
                gameData.letterColor = gameData.dotColors[i];

                this.pCont.tintLetters(gameData.dotColors[i]);
                
                this.tweenInCursor(gameData.dotColors[i]);
            }, this.tray);

            color.tint = gameData.dotColors[i];
            color.x = i%2 ? 15 : -15;
            color.y = -170 + (28*i);
            color.setScale(.66, .66);

            this.btns.push(color);
        }
    }

    createSizeTray()
    {
        for(let i=1;i<=3;i++){
            let brush = this.scene.addButton(0, 0, "brush", null, ()=>{
                this.scene.playSound("select_color_pattern_face");

                gameData.brushSize = brush.brushSize;
                this.tweenInCursor(brush.brushSize);
                this.scene.faceMask.setPaintColor();

                gameData.isErasing = false;
            }, this.tray);

            brush.brushSize = i;
            brush.x = 0;
            brush.y = -185 + (55*i);
            brush.setScale(this.cursorSizes[0][i-1], this.cursorSizes[0][i-1]);
            if(i === 3) brush.y -= 10;

            this.btns.push(brush);
        }

        let eraser = this.scene.addButton(0, 5, "Btn_Eraser", null, ()=>{
            this.scene.playSound("select_color_pattern_face");

            gameData.brushSize = eraser.brushSize;
            this.tweenInCursor(eraser.brushSize);

            gameData.isErasing = true;
        }, this.tray);
        eraser.brushSize = 4;
        this.btns.push(eraser);
    }

    toggleBtns(onOff)
    {
        for(let i=0;i<this.list.length;i++){
            if(this.list[i] instanceof Abutton) this.list[i].setEnabled(onOff);
        }
    }

    tweenInCursor(color)
    {
        let dot;
        typeof color === "string" ? dot = this.btns[gameData.dotColors.indexOf(color)] : dot = this.btns[color-1];
        this.cursor.x = dot.x;
        
        this.cursor.setScale(0, 0);
        this.scene.killTween(this.cursor);
        if(this.type === "color"){
            this.cursor.y = dot.y + dot.height/2 - 8;

            this.cursor.tint = "0xef608c";
            
            this.scene.addTween(this.cursor, 500, {scaleX:.66, scaleY:.66}, Phaser.Math.Easing.Back.Out);
        }
        else {
            if(color === 1) this.cursor.y = dot.y + dot.height/2;
            else if(color === 2) this.cursor.y = dot.y + dot.height/2 - 4;
            else if(color === 3) this.cursor.y = dot.y + dot.height/2 - 9;
            else this.cursor.y = dot.y + dot.height/2;

            this.cursor.tint = "0x6c52cc";

            this.scene.addTween(this.cursor, 500, {scaleX:this.cursorSizes[1][color-1], scaleY:this.cursorSizes[1][color-1]}, Phaser.Math.Easing.Back.Out);
        }
    }

    setBtnTint(tint)
    {
        this.btns.forEach(btn => {if(btn.brushSize !== 4) btn.tint = tint;});
    }

    tweenOutCursor()
    {
        this.scene.killTween(this.cursor);
        this.scene.addTween(this.cursor, 100, {scaleX:0, scaleY:0}, Phaser.Math.Easing.None);
    }

    tweenInTray()
    {
        this.scene.killTween(this.tray);
        this.scene.addTween(this.tray, 500, {x:179}, Phaser.Math.Easing.Quadratic.Out)
    }

    tweenOutTray()
    {
        this.scene.killTween(this.tray);
        this.scene.addTween(this.tray, 300, {x:95}, Phaser.Math.Easing.Quadratic.Out);
    }

    cleanUp()
    {
        this.toggleBtns(false);
        
        this.cursor.destroy();
        this.tray.destroy();
        this.trayBG.destroy();
        this.btns.forEach(btn => {btn.destroy();});
    }
}